import { useMemo } from "react";
import { Clock } from "@phosphor-icons/react";
import { formatDateIT } from "@/lib/formatDate";
import { OverviewCard, OverviewEmpty } from "./Card";

function relativeFromIso(isoDate) {
  if (!isoDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const m = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  d.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - d) / 86400000);
  if (diffDays === 0) return "oggi";
  if (diffDays === 1) return "ieri";
  if (diffDays < 0) return `tra ${Math.abs(diffDays)} g`;
  if (diffDays < 30) return `${diffDays} g fa`;
  const months = Math.round(diffDays / 30);
  if (months < 12) return `${months} mese${months === 1 ? "" : "i"} fa`;
  const years = Math.round(months / 12);
  return `${years} ann${years === 1 ? "o" : "i"} fa`;
}

function maxDate(items, field) {
  if (!items?.length) return null;
  return items.reduce((max, item) => {
    const v = item?.[field];
    if (!v) return max;
    if (!max || v > max) return v;
    return max;
  }, null);
}

/**
 * Extra widget (b) — Ultima attività.
 * Aiuta il coach a vedere a colpo d'occhio quanto è "vivo" il cliente.
 */
export function LastActivityWidget({ logs, measurements, checkinResponses }) {
  const items = useMemo(() => {
    const log = maxDate(logs, "date");
    const meas = maxDate(measurements, "date");
    const ck = maxDate(checkinResponses, "submitted_at")
      || maxDate(checkinResponses, "week_start");
    return [
      { label: "Ultimo log", value: log },
      { label: "Ultima misura", value: meas },
      { label: "Ultimo check-in", value: ck ? ck.slice(0, 10) : null },
    ];
  }, [logs, measurements, checkinResponses]);

  const anyActivity = items.some((i) => i.value);

  return (
    <OverviewCard
      title="Ultima attività"
      icon={Clock}
      iconColor="text-[#FF9F0A]"
      testId="overview-last-activity"
    >
      {!anyActivity ? (
        <OverviewEmpty message="Nessuna attività registrata ancora." />
      ) : (
        <ul className="space-y-2">
          {items.map((i) => (
            <li key={i.label} className="flex items-center justify-between text-xs">
              <span className="text-zinc-500">{i.label}</span>
              {i.value ? (
                <span className="text-white font-medium">
                  {relativeFromIso(i.value)}
                  <span className="text-zinc-600 ml-1.5">· {formatDateIT(i.value)}</span>
                </span>
              ) : (
                <span className="text-zinc-600 italic">mai</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </OverviewCard>
  );
}
